import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setPostCreateTournament = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_CREATE_TOURNAMENT
            });

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostCreateTournament as SetPostCreateTournament
}